
// hide-header.directive.ts - this directive will do the actual job to hide header on content scroll in Ionic Framework.

import { Directive, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { DomController, Platform } from '@ionic/angular';

@Directive({
    selector: '[hide-header]',
    standalone: false
})
export class HideHeaderDirective implements OnInit
{

	@Input('header') header: any;

	/**
	 * Minimum scroll offset from top in pixels until the animation kicks in.
	 */
	@Input('scrollThreshold') scrollThreshold: number = 200;

	private lastY = 0;

	constructor(
		private renderer: Renderer2,
		private domCtrl: DomController,
		private platform: Platform
	) { }

	ngOnInit(): void
	{
		this.header = this.header.el;
		this.domCtrl.write(() =>
		{
			this.renderer.setStyle(this.header, 'transition', 'margin-top 700ms');
		});
	}

	@HostListener('ionScroll', ['$event']) onContentScroll($event: any)
	{
		var isMobile = this.platform.width() < 1280;
		if (isMobile && $event.detail.deltaY > this.scrollThreshold) 
		{
			this.domCtrl.write(() =>
			{
				this.renderer.setStyle(this.header, 'margin-top', `-${this.header.clientHeight}px`);
			});
		}
		else if ($event.detail.scrollTop < 100 || $event.detail.deltaY < -50)
		{
			this.domCtrl.write(() =>
			{
				this.renderer.setStyle(this.header, 'margin-top', '0');
			});
		}
	}

}